/**
 * Chat slash command definitions and help text.
 */

import type { ChatCommand } from './chat-command-menu';

export const COMMANDS: ChatCommand[] = [
  { name: 'new', description: 'Start a new conversation' },
  { name: 'history', description: 'Show conversation history' },
  { name: 'clear', description: 'Clear chat history' },
  { name: 'ping', description: 'Check pipeline readiness' },
  { name: 'help', description: 'Show available commands' },
  { name: 'verse', description: 'Go to verse — /verse John 3:16', hasArg: true },
  { name: 'strongs', description: "Look up Strong's — /strongs H1234", hasArg: true },
];

export const HELP_TEXT = [
  '**Available commands:**',
  '`/new` — Start a new conversation',
  '`/history` — Show conversation history',
  '`/clear` — Clear chat history',
  '`/verse <ref>` — Navigate to a verse (e.g. /verse John 3:16)',
  '`/strongs <number>` — Look up a Strong\'s number (e.g. /strongs H1234)',
  '`/ping` — Check pipeline readiness (Ollama, ChromaDB, hardware)',
  '`/help` — Show this message',
  '',
  '**Sharing:**',
  'Click the link icon on any message to copy a shareable deep link.',
  'Opening a deep link starts a fresh conversation automatically.',
  '',
  '**Keyboard:**',
  '↑ / ↓ — Recall previous prompts',
].join('\n');
